import React from 'react';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import WrappedTooltip from './overlay/WrappedTooltip.component';

const UIElementWrapperLabel = ({ label, inputId }) => {
	if (label) {
		return (
			<div className="label-container">
				<label htmlFor={inputId} data-qa="ui-label" {...{ dataqa: 'ui-label' }}>
					{label}
				</label>
			</div>
		);
	}

	return null;
};

const UIElementWrapperErrorTooltip = props => {
	const { isInputInvalid, showErrorBelow, errorMessage, errorTooltipOptions } = props;
	const cls = classNames('common-ui-error-container', {
		'common-ui-error-text': showErrorBelow,
	});

	if (isInputInvalid && showErrorBelow) {
		return (
			<div className={cls}>
				<div className="invalid-error-icon" />
				<span className="error-msg" data-qa="ui-error" {...{ dataqa: 'ui-error' }}>
					{errorMessage}
				</span>
			</div>
		);
	} else if (isInputInvalid) {
		const targetId = `invalid-error-icon-${uniqueId()}`;

		return (
			<div className={cls}>
				<div className={classNames('invalid-error-icon', targetId)} />

				<WrappedTooltip
					tooltip={errorMessage}
					target={targetId}
					className="tooltip-error"
					{...errorTooltipOptions}
				/>
			</div>
		);
	}

	return null;
};

/**
|---------------------------------------------------------------------------------
| This is a Higher-Order component (HOC) for adding common features (label and
| error tooltip) to components. It takes a component as an argument and returns a
| component, a functional component. See the documenation for more details,
| https://reactjs.org/docs/higher-order-components.html
|---------------------------------------------------------------------------------
*/
const UIElementWrapper = (WrappedComponent, wrapperCls) => props => {
	const {
		className,
		errorMessage,
		errorTooltipOptions,
		isInputInvalid = false,
		label,
		showLabelAfter = false,
		showErrorBelow = false,
		uiElementConfig,
	} = props;

	const { disabled } = uiElementConfig;

	const elementWrapperCls = classNames(
		'common-ui-element-wrapper',
		wrapperCls,
		className,
		disabled ? 'disabled' : '',
		{
			'mobile-wrapper': showErrorBelow === true,
		}
	);

	const inputId = uiElementConfig.id
		? uiElementConfig.id
		: `inputId-${Math.random()
				.toString(36)
				.substr(2, 9)}`;

	return (
		<div className={elementWrapperCls}>
			{!showLabelAfter && <UIElementWrapperLabel label={label} />}

			<div className="input-container">
				<WrappedComponent
					{...uiElementConfig}
					isInputInvalid={isInputInvalid}
					id={inputId}
				/>
				<UIElementWrapperErrorTooltip
					isInputInvalid={isInputInvalid}
					showErrorBelow={showErrorBelow}
					errorMessage={errorMessage}
					errorTooltipOptions={errorTooltipOptions}
				/>
				{showLabelAfter && <UIElementWrapperLabel label={label} />}
			</div>
		</div>
	);
};

export default UIElementWrapper;
